import React, { useMemo } from 'react'

import { Box } from '@mui/material'
import AccountInfo from './AccountDetails/AccountInfo'
import SpinningCircle from '@/src/components/SpinningCircle'
import { ServiceCenterMobile } from '@/components/Account/ServiceCenter'
import { useBackend } from '@/src/providers/BackendProvider'
import ContactAudiologist from '@/components/Account/ContactAudiologist'
import MyOrders from '@/components/Account/MyOrders'
import styles from '@/src/components/scss/Account/AccountRouter.module.scss'

const AccountRouterMobile = (props) => {
  const currentView = props.currentView
  const setCurrentView = props.setCurrentView
  const userInfo = props.info
  const setValue = props.setValue
  // console.log(currentView)
  const { loading } = useBackend()

  const res = useMemo(() => {
    if (loading) {
      return (
        <div>
          <SpinningCircle />
        </div>
      )
    }
    return (
      <Box className={styles.mobileWrapper} mt={2}>
        {currentView === 'detail' && (
          <AccountInfo info={userInfo} setCurrentView={setCurrentView} currentView={currentView} setValue={setValue} />
        )}

        {currentView === 'service' && <ServiceCenterMobile prefittingStat={props.prefittingStat} />}

        {currentView === 'orders' && <MyOrders />}

        {currentView === 'audiologist' && <ContactAudiologist />}
      </Box>
    )
  }, [loading, currentView, userInfo, props.prefittingStat])

  return <div>{res}</div>
}

export default AccountRouterMobile
